<div class="panel">
  <h2>User Count Report</h2>
  <div class="container">
    
    <div class="grid">
      <div class="col-2"><label>Project Name:</label></div>
      <div class="col-6"><span>{{(project | async)?.Name}}</span></div>
    </div>
    <div class="grid">
      <div class="col-2"><label>Primavera Project Id:</label></div>
      <div class="col-6"><span>{{(project | async)?.ProjectId}}</span></div>
    </div>
    <div class="grid">
      <div class="col-12">
        <app-return-to-delta-report-btn [projectObjectId]="this.queryParams.projectObjectId"></app-return-to-delta-report-btn>
      </div>
    </div>
  </div>
  <hr>

<div class="container">
  <div class="grid align-items-end">
    <div class="col-4">
      <div style="display: flex; flex-wrap: wrap; gap: 16px;">
        <span *ngFor="let row of groupedRoles">
          <b>{{ row.role }}</b>: {{ row.count }}
        </span>
      </div>
    </div>
    <div class="col-4" style="margin-top: 10px;">
      <div style="display: flex; align-items: center;">
        <b style="margin-right: 8px;">Filter By Hours:</b>
        <select id="hoursSelect" class="form-select mt-1" style="width:auto;" [(ngModel)]="selectedHours" (change)="onHoursChange($event)">
          <option [ngValue]="24">24 Hours</option>
          <option [ngValue]="48">48 Hours</option>
          <option [ngValue]="168">Last 7 Days</option>
          <option [ngValue]="720">Last 30 Days</option>
          <option [ngValue]="1440">Last 60 Days</option>
        </select>
      </div>
    </div>
    <div class="col-4" style="margin-top: 10px;">
      <div style="display: flex; align-items: center;">
        <b style="margin-right: 8px;">Filter By Role:</b>
        <select id="roleFilter" class="form-select mt-1" style="width:auto;" [(ngModel)]="selectedRoleFilter" (change)="onRoleFilterChange()">
          <option [ngValue]="''">All</option>
          <option [ngValue]="'Contract Foreman'">Contract Foreman</option>
          <option [ngValue]="'Company Rep'">Company Rep</option>
        </select>
      </div>
    </div>
  </div>

  <div class="container">
    <p-table
      #dt
      [value]="filteredUsers"
      [paginator]="true"
      [rows]="10"
      showGridlines
      sortMode="multiple"
      [globalFilterFields]="['UserName', 'Email', 'CrewLabel', 'Updateddate', 'UpdatedInTimeFrame']"
    >
      <ng-template pTemplate="caption">
        <div class="mb-3" style="margin-top: 10px;">
          <input
            type="text"
            pInputText
            placeholder="Search..."
            style="width: 300px;"
            (input)="dt.filterGlobal($event.target.value, 'contains')"
          />
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="UserName">User Name <p-sortIcon field="UserName"></p-sortIcon></th>
          <th pSortableColumn="Email">Email <p-sortIcon field="Email"></p-sortIcon></th>
          <th pSortableColumn="Type">Crew <p-sortIcon field="Type"></p-sortIcon></th>
          <th pSortableColumn="Updateddate">Time Updated <p-sortIcon field="Updateddate"></p-sortIcon></th>
          <th pSortableColumn="UpdatedInTimeFrame">Status <p-sortIcon field="UpdatedInTimeFrame"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr>
          <td>{{ user.UserName }}</td>
          <td>{{ user.Email }}</td>
          <td>
            <span>
              {{ getCrewLabel(user.Type) }}
            </span>
          </td>
          <td>
            {{ user.Updateddate ? (user.Updateddate | date:'medium') : 'Never' }}
          </td>
          <td>
            <span 
              [ngStyle]="{
                'color': user.UpdatedInTimeFrame ? 'green' : 'red'
              }">
              {{ user.UpdatedInTimeFrame 
                ? 'Updated in last ' + getSelectedHoursLabel() 
                : 'Not updated in last ' + getSelectedHoursLabel() }}
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
